import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { createStoreValidator } from '@core/helpers/create-validator.helper';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { toNum } from '@shared/helpers/math.helper';

@Injectable()
export class DatiIdentificativiFieldValidators {
    constructor(private readonly store: Store<Revisione53State>) {}

    my_TipoIncaricoEffettivo = createStoreValidator(this.store, (myVerbale) => {
        const my_TipoIncaricoEffettivo = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoIncaricoEffettivo;

        if (toNum(my_TipoIncaricoEffettivo) === 0) {
            return {
                my_TipoIncaricoEffettivo: {
                    status: 'Valore non valido',
                },
            };
        }

        return null;
    });
}
